import type { Tracking } from "@otto-ec/tracking-bct";
import type { DataTrMethodParameterMap as DataTrMethodParameterMap } from "./parser/params.js";
import type { NexusSignalAssignable } from "../nexus/event/event.types";
import type { ReleaseLock } from "./init/defer";
import type { AsyncNamespace } from "../nexus/namespace/namespace.types";
import type { NexusResult } from "../nexus/function/function.types";
import type {
  DataTrEventData,
  DataTrLifeCycleEventMap,
  DataTrSynteticEventMap,
} from "./event/event.types.js";
import type { GetOriginalEventType } from "./event/event.js";

/**
 *
 *
 */
export const PREFIX = "tr-v1";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type DataTrSubmitTrackingDetail<
  TrackingMethod extends keyof Tracking,
  OriginalEvent extends string = string,
> = {
  /**
 *
 *
 *
 *
 *
 *
 */
  event: GetOriginalEventType<OriginalEvent>;
  /**
 *
 *
 *
 *
 *
 *
 *
 */
  eventName: OriginalEvent;
  /**
 *
 *
 *
 */
  method: TrackingMethod;
  /**
 *
 *
 *
 *
 *
 */
  parameters: Parameters<Tracking[TrackingMethod]>;
  /**
 *
 *
 *
 *
 *
 */
  parameterMap: DataTrMethodParameterMap[TrackingMethod];

  /**
 *
 *
 */
  abort(): void;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export interface DataTrExtraEventDetail<TrackingMethod extends keyof Tracking = keyof Tracking> {
  /**
 *
 *
 */
  [PREFIX]: DataTrEventData<TrackingMethod>;
}

declare global {
  /*                                                */
  interface ElementEventMap extends DataTrLifeCycleEventMap, DataTrSynteticEventMap {}
  /*                                                */
  interface DocumentEventMap extends DataTrLifeCycleEventMap, DataTrSynteticEventMap {}

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  /*                                                */
  interface DataTrSubmitTrackingOriginalEventMap extends DataTrSynteticEventMap {}

  interface NexusInterfaces {
    /**
 *
 */
    [PREFIX]: AsyncNamespace<DataTrRaw>;
  }
}

/**
 *
 */
export type DataTrRaw = {
  /**
 *
 *
 *
 *
 *
 */
  onInit: NexusSignalAssignable;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  lockInit(lockToken: string | symbol | object): NexusResult<ReleaseLock>;

  /**
 *
 *
 *
 *
 *
 *
 */
  unlockInit(lockToken: string | symbol | object): NexusResult<boolean>;
};
